import * as React from 'react';

import { Toggle } from '@rbilabs/components-library';
import styled from 'styled-components/native';

import { SearchBar } from '../search-bar';
import { StoreLocatorViews } from '../types';

import { ClearStoreSmButton } from './clear-store-sm-button';
import { FittedViewContainer } from './fitted-view-container';
import { ListView } from './list-view';
import { MapView } from './map-view';
import {
  Header,
  HeaderBackground,
  HeaderWrapper,
  MaxWidth,
  MaxWidthFullHeight,
  SearchBarWrapper,
  SearchContainer,
  ServiceModeCategoryToggleWrapper,
  ToggleViewButtonWrapper,
} from './store-locator.styled';
import { ToggleViewButton } from './toggle-view-button';
import { IStoreLocatorViewProps } from './types';

const StoreLocatorWrapper = styled.SafeAreaView`
  height: calc(100vh - 51px);
`;

export const StoreLocatorView: React.VFC<IStoreLocatorViewProps> = ({
  activeCoordinates,
  errorFavs,
  errorNearby,
  errorRecent,
  handleResetLocation,
  searchingNearby,
  searchingRecent,
  searchingFavs,
  storesFavs = [],
  storesNearby = [],
  storesRecent = [],

  // Map View
  onSearchClick,

  // View
  currentView,
  onViewChange,

  // Search Bar
  onAddressSelected,
  onSearchBarValueChange,
  searchBarValue,
  shouldFocusSearchBar,

  // Service Mode Category
  hideServiceModeCategories = false,
  onServiceModeCategoryChange,
  selectedServiceModeCategory,
  serviceModeCategoryOptions = [],
}) => {
  return (
    <StoreLocatorWrapper>
      <FittedViewContainer data-testid="store-locator-wrapper">
        <HeaderBackground>
          <MaxWidth>
            <HeaderWrapper>
              <ClearStoreSmButton />

              <Header>Locations</Header>

              <ToggleViewButtonWrapper>
                <ToggleViewButton currentView={currentView} updateStoreLocatorView={onViewChange} />
              </ToggleViewButtonWrapper>
            </HeaderWrapper>
          </MaxWidth>
        </HeaderBackground>

        <MaxWidth>
          <SearchContainer>
            {!hideServiceModeCategories ? (
              <ServiceModeCategoryToggleWrapper>
                <Toggle
                  data-testid="service-mode-category-toggle"
                  options={serviceModeCategoryOptions}
                  onChange={onServiceModeCategoryChange}
                  value={selectedServiceModeCategory}
                />
              </ServiceModeCategoryToggleWrapper>
            ) : null}

            <SearchBarWrapper>
              <SearchBar
                autoFocus={shouldFocusSearchBar}
                value={searchBarValue}
                onInputValueChange={onSearchBarValueChange}
                onAddressSelected={onAddressSelected}
              />
            </SearchBarWrapper>
          </SearchContainer>
        </MaxWidth>

        {/* ListView can be mounted and unmounted. */}
        {currentView === StoreLocatorViews.LIST_VIEW ? (
          <MaxWidth>
            <ListView
              errorFavs={errorFavs}
              errorNearby={errorNearby}
              errorRecent={errorRecent}
              searchingNearby={searchingNearby}
              searchingRecent={searchingRecent}
              searchingFavs={searchingFavs}
              storesFavs={storesFavs}
              storesNearby={storesNearby}
              storesRecent={storesRecent}
            />
          </MaxWidth>
        ) : null}

        <MaxWidthFullHeight>
          {/* MapView remains mounted and manages showing and hiding internally. */}
          <MapView
            activeCoordinates={activeCoordinates}
            currentViewIsMap={currentView === StoreLocatorViews.MAP_VIEW}
            handleResetLocation={handleResetLocation}
            onSearchClick={onSearchClick}
            storesFavs={storesFavs}
            storesNearby={storesNearby}
            storesRecent={storesRecent}
          />
        </MaxWidthFullHeight>
      </FittedViewContainer>
    </StoreLocatorWrapper>
  );
};
